export const scopes = {
  AI_EMAIL_ENRICHMENT_ADMIN: 'ai-email-enrichment-admin',
  BILLING_ACCESS: 'billing-access',
  BREEZE_INTELLIGENCE_FREE: 'breeze-intelligence-free',
  CONVERSATIONAL_ENRICHMENT_BASIC: 'conversational-enrichment-basic-access',
  CONVERSATIONAL_ENRICHMENT_PREMIUM: 'conversational-enrichment-premium-access',
  DATA_AGENT_ACCESS: 'data-agent-access',
  DATA_AGENT_PLATFORM_ACCESS: 'data-agent-platform-access',
  DATA_ENRICHMENT_ACCESS: 'data-enrichment-access',
  ENRICHMENT_PLATFORM_ACCESS: 'data-enrichment-platform-access',
  MANAGE_DATA_ENRICHMENT: 'manage-data-enrichment',
  PROPERTY_SETTINGS: 'crm-property-settings',
  PROPERTY_SETTINGS_WRITE: 'properties-settings-write',
  CONVERSATIONAL_ENRICHMENT_TRANSCRIPT_PROCESSING_BASIC: 'conversational-enrichment-transcripts-access'
};